// AdviserDetailsController
app.controller('AdviserDetailsController', ['$scope', 'WdHttpService', '$routeParams',
    function($scope, WdHttpService, $routeParams) {

        // Init 
        $scope.init = async function() {
            $scope.isVisible = false;
            if (!$scope.adviserUsername && $routeParams.fundname) {
                $scope.adviserUsername = await WdHttpService._get_adviserUsername($routeParams.fundname);
            } else if (!$scope.adviserUsername && !$routeParams.fundname && $scope.isAdviser) {
                $scope.adviserUsername = $scope.distributorUsername;
            }

            if ($scope.adviserUsername) {
                $scope.adviserBusinessDetails = await WdHttpService._get_adviser_details({ adviserUsername: $scope.adviserUsername });
            }
            $scope.$evalAsync();
        }

        $scope.toggleView = function() {
            $scope.isVisible = !$scope.isVisible;
            $scope.$evalAsync();
        }

        $scope.showScoreModal = async function() {
            $scope.showPageLoader();
            if ($scope.isAdviser)
                $scope.scoreData = await WdHttpService._get_adviser_scores_details({ adviserUsername: $scope.distributorUsername });
            else if (!$scope.isAdviser || !$scope.adviserUsername) {
                $scope.adviserUsername = $scope.adviserUsername ? $scope.adviserUsername : await WdHttpService._get_adviserUsername($routeParams.fundname);
                $scope.scoreData = await WdHttpService._get_adviser_scores_details({ adviserUsername: $scope.adviserUsername });
            }
            $scope.hidePageLoader();
            $('#scoreModel').modal('show');
        }
        $scope.showInvestmentCharterModal = async function() {
            $scope.showPageLoader();
            if ($scope.adviserDetails['custom:metadata']['isRIA'] == 'RIA') {
                $('#riaInvestmentCharterModel').modal('show');
            } else {
                $('#raInvestmentCharterModel').modal('show');
            }
            $scope.hidePageLoader();

        }
    }
]);